var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitePlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_136_1",
    "data-name": "Component 136 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.438,
    height: 24.438,
    viewBox: "0 0 24.438 24.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13815",
    "data-name": "Path 13815",
    d: "M12.219,0A12.219,12.219,0,1,1,0,12.219,12.219,12.219,0,0,1,12.219,0Z",
    fill: "#810055"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14159",
    "data-name": "Group 14159",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_411",
    "data-name": "Line 411",
    x2: 12.71,
    transform: "translate(0 5.981)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_412",
    "data-name": "Line 412",
    y2: 11.962,
    transform: "translate(6.729 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlus);
export default __webpack_public_path__ + "static/media/white-plus.f1e6bbf2143c20d39f4b757191b15be1.svg";
export { ForwardRef as ReactComponent };